import {AfterViewInit, Component, OnInit, ViewChild, ViewEncapsulation} from '@angular/core';
import {language} from '../../../../language/vn';
import {FormGroup, FormControl, FormBuilder, Validators} from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import {first} from 'rxjs/operators';
import {validateEmpty} from '../../../../global/custom-validate';
import {BsModalRef, BsModalService} from 'ngx-bootstrap/modal';
import * as ClassicEditor from '@ckeditor/ckeditor5-build-decoupled-document';
import {UploadFileComponent} from '../../../ui/upload/uploadfile.component';
import {HoSoService} from '../../../../service/hoso/service-hoso';
import {HoSoFileService} from '../../../../service/hoso/service-hosofile';
import {Subject} from 'rxjs';
import {HoSoFile} from '../../../../models/hoso/hosofile';
import {SessionToken} from '../../../../models/staff/sessiontoken';
import {Sessioncommand} from '../../../../global/sessioncommand';
import {environment} from '../../../../../environments/environment';
import {SelectStaffComponent} from '../../../ui/selectstaff/selectstaff.component';
import {GroupSelectComponent} from '../../group/groupselect.component';
import {HoSoShareService} from '../../../../service/hoso/service-hososhare';

@Component({
  templateUrl: './share.component.html'

})
export class ShareHoSoComponent implements OnInit, AfterViewInit {
  @ViewChild(SelectStaffComponent)
  public uiSelectStaff: SelectStaffComponent;
  @ViewChild(UploadFileComponent)
  public uploadFileComponent: UploadFileComponent;
  public language = language;
  public id: number=0;
  public isEdit: boolean = false;
  public submitValidate = false;
  public editor = ClassicEditor;
  public uploadUrl: String;
  public deleteUrl: String;
  public fileLists: Object[];
  public staffSelectList: Object[]=[];
  public selectedList: Object[]=[];
  public ghiChu: string = '';
  public tenHoSo: string = '';
  public onClose: Subject<boolean>;
  constructor( public hoSoShareService: HoSoShareService,
               public toastr: ToastrService,
               public bsModalService: BsModalService,
               public _bsModalRef: BsModalRef,
               public hoSoService: HoSoService

  ) {
  }
  ngAfterViewInit() {

  }
  ngOnInit(): void {
    this.onClose = new Subject();
  }
	public onReady( editor ) {
    editor.ui.getEditableElement().parentElement.insertBefore(
      editor.ui.view.toolbar.element,
      editor.ui.getEditableElement()
    );
    editor.editing.view.change( writer => {
      writer.setStyle( 'height', '300px', editor.editing.view.document.getRoot() );
      writer.setStyle( 'border', '1px solid', editor.editing.view.document.getRoot() );
    } );
  }
  public edit(id: number) {
      this.id= id;
      this.hoSoService.getById(id).subscribe(x=>{
        this.tenHoSo = x.tenHoSo;
      });
  }
  public createItem ()
  {


    this.hoSoShareService.addShare(this.id, Sessioncommand.staffId, this.uiSelectStaff.selected.join(), this.ghiChu).subscribe(
      {
        next: (data) => {
          this.toastr.success(language.message_share_hoso_success, language.message);
          this.onConfirm();
        },
        error: error => {
          this.toastr.error(language.error, language.message);
        }
      });
  }

  public showGroup()
  {
    const modalEdit = this.bsModalService.show(GroupSelectComponent, {class: 'modal-xl', keyboard: false, backdrop: 'static'});
    (<GroupSelectComponent>modalEdit.content).showDonVi(
      this.staffSelectList
    );
    (<GroupSelectComponent>modalEdit.content).selectStaffs.subscribe(result => {
      if(result != null)
      {
        for (let i = 0; i < result.length; i++) {

          if(this.staffSelectList.some(e => e["id"] === result[i].id)==false) {
            this.staffSelectList= [...this.staffSelectList, {id: result[i].id, fullName: result[i].fullName}];
            this.selectedList= [...this.selectedList, result[i].id];
          }
        }
      }
    });
  }
  onSubmit()
  {
    if(this.uiSelectStaff.selected.length>0) {
      this.createItem();
    }
    else {
      this.toastr.error(language.error_select_staff_share, language.message);
    }
  }
  public onConfirm(): void {

    this.onClose.next(true);
    this._bsModalRef.hide();
  }

  public onCancel(): void {
    this.onClose.next(false);
    this._bsModalRef.hide();
  }

  public hideConfirmationModal(): void {
    this.onClose.next(null);
    this._bsModalRef.hide();
  }

}

